import axios, {AxiosResponse} from 'axios'
import {EvidenceQueryResponse} from '../../../models/IEvidence'
import {CaseStatusQueryResponse} from './_model'

const API_URL = process.env.REACT_APP_BASE_API_URL
const URL = `${API_URL}/case-status`

const getCaseStatus = (query: string): Promise<CaseStatusQueryResponse> => {
  return axios.get(`${URL}?${query}`).then((d: AxiosResponse<CaseStatusQueryResponse>) => d.data)
}

export {
  getCaseStatus,
}